import { CollectionPath } from '../../data/paths'

export const USERSPATHS = {
  users: new CollectionPath('users', {
    settings: new CollectionPath<{ 'stripe': any }>('settings')
  })
}
